import { fetchOptions } from "./api";
import { getApiKey } from "./../selectors";
import utils from "../utils/index";

export const getConservatoryTypes = () => {
    return (dispatch, getState) => {
        return dispatch({
            type: "GET_CONSERVATORY_TYPES",
            payload: fetchOptions(getApiKey(getState()), "GetProducts?suiteId=4")
        });
    };
};

export function getConservatoryStyles(conservatoryTypeId) {
    return (dispatch, getState) =>{
        dispatch({
            type: "GET_CONSERVATORY_STYLES",
            payload: fetchOptions(getApiKey(getState()), "GetStyles?productId=" + conservatoryTypeId)
        });
    };
}

export function getConservatoryExtras(conservatoryTypeId) {
    return (dispatch, getState) =>{
        dispatch({
            type: "GET_CONSERVATORY_EXTRAS",
            payload: fetchOptions(getApiKey(getState()), "GetProductOptions?productId=" + conservatoryTypeId + "&roomId=25")
        });
    };
}

export function addConservatory(conservatoryValues) {
    return (dispatch, getState) =>{
        let randomIdForImageReplacement = Math.floor(1e10 * Math.random());
        var state = getState();
        var canvas = document.createElement("CANVAS");
    
        canvas.width = 219;
        canvas.height = 228;
    
        var context = canvas.getContext("2d");

        var imageSrc = utils.getValueById(
            state.Conservatory.Styles,
            conservatoryValues.ConservatoryTypeId
        ).externalImageUrl + "?v=" + new Date().getTime();
    
        var image = new Image();
        image.crossOrigin = "Anonymous";
        image.onload = () => {
            context.drawImage(image, 0, 0, 219, 228);
            var imgUrl = canvas.toDataURL();
            dispatch({
                type: "LOAD_FLAT_IMAGE",
                payload: {
                    randomIdForImageReplacement,
                    imgUrl
                }
            });
        };
        image.src = imageSrc;

        dispatch({
            type: "ADD_CONSERVATORY_TO_LIST",
            payload: {
                ...conservatoryValues,
                FlattenedImageSrc: "",
                randomIdForImageReplacement
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/actions/conservatory.js